import CaseDifficultyEmpty from './case-difficulty-empty.svg';
import CaseDifficultyEasy from './case-difficulty-easy.svg';
import CaseDifficultyMedium from './case-difficulty-medium.svg';
import CaseDifficultyHard from './case-difficulty-hard.svg';
import CaseDifficultyVeryHard from './case-difficulty-very-hard.svg';

export const Icons = {
  CaseDifficultyEmpty,
  CaseDifficultyEasy,
  CaseDifficultyMedium,
  CaseDifficultyHard,
  CaseDifficultyVeryHard,
};
